import React, {memo} from 'react';
import {Col, Row} from 'components/Grid';
import Picture from 'components/Picture';
import PlayButton from 'modules/brands/components/PlayButton';
import {IBrand} from 'modules/brands/models';
import style from './style.module.scss';
import {getMediaSrc} from 'core/helpers/media';
import {TPropsWithClassName} from 'core/types';
import classNames from 'classnames';

type TBrandXBannerProps = Pick<IBrand, 'presentation' | 'mainPhoto'> &
    TPropsWithClassName & {
        onClick: () => void;
    };

export const BrandXBanner = memo<TBrandXBannerProps>(({presentation, mainPhoto, onClick, className}) => (
    <Row>
        <Col className={classNames(style.bannerWrap, className)}>
            <>
                <Picture role={'presentation'} sources={{}} src={getMediaSrc(mainPhoto.url)} />
                {Boolean(presentation?.url) && (
                    <div className={style.playButtonWrap}>
                        <PlayButton onClick={onClick} />
                    </div>
                )}
            </>
        </Col>
    </Row>
));
